import type { SVGProps } from 'react';
const SvgPaperclip = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
    <path d="M375 73c-26-26-68.1-26-94.1 0L89 265c-43.7 43.6-43.7 114.4 0 158s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39c44.7-44.7 117.2-44.7 162 0s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8 10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z" />
  </svg>
);
export default SvgPaperclip;
